import { StyleSheet } from 'aphrodite'
import { Colours } from '../../../style_helpers'

export const baseStyles = StyleSheet.create({
  base: {
    position: 'relative',
    background: 'transparent',
    border: '1px solid transparent',
    textShadow: '0px 0px 0px transparent',
    transition: 'background-color 200ms ease 0s, border 200ms ease 0s, color 200ms ease 0s, box-shadow 200ms ease 0s',

    ':hover': {
      background: 'transparent',
      boxShadow: '0px 0px 0px transparent',
      border: '1px solid transparent',
      textShadow: '0px 0px 0px transparent'
    },

    ':active': {
      border: '1px solid transparent',
      outline: 'none'
    },

    ':focus': {
      outline: '0'
    }
  }
})

export const fullWidthStyles = StyleSheet.create({
  fullWidth: {
    width: '100%'
  }
})

export const condensedStyles = StyleSheet.create({
  condensed: {
    width: '120px',
    height: '40px',
    padding: '11px 16px'
  }
})

export const standardStyles = StyleSheet.create({
  standard: {
    width: '150px',
    height: '48px',
    padding: '15px 16px'
  }
})
export const largeStyles = StyleSheet.create({
  large: {
    width: '180px',
    height: '56px',
    padding: '19px 16px'
  }
})

export const circularStyles = StyleSheet.create({
  condensed: {
    width: '40px',
    height: '40px',
    padding: '8px'
  },
  standard: {
    width: '48px',
    height: '48px',
    padding: '12px'
  },
  large: {
    width: '56px',
    height: '56px',
    padding: '16px'
  }
})

export const loadingIconStyles = {
  width: '16px',
  height: '16px',
  lightTheme: {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    foregroundColor: Colours('white', 300)
  },
  darkTheme: {
    backgroundColor: 'rgba(28, 189, 207, 0.25)',
    foregroundColor: Colours('uiBlue', 300)
  }
}

export const contentStyles = StyleSheet.create({
  base: {
    position: 'absolute',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '78.66%',
    lineHeight: '17.6px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  },
  loading: {
    height: '16px'
  },
  largeIcon: {
    height: '24px'
  }
})
